import { useState, useCallback, useEffect } from 'react';
import { useAuth } from './useAuth';
import { api } from '../api';
import { STATIC } from '../staticMode';
import { progressStore } from '../staticStore';

// Reading progress (text_id -> item index). Backend-backed in dev; localStorage in static.
export function useProgress() {
  const { token } = useAuth();
  const [progress, setProgress] = useState(() => (STATIC ? progressStore.getAll() : {}));
  const [ready, setReady] = useState(STATIC);   // static: localStorage ready synchronously

  useEffect(() => {
    if (STATIC) return;
    setReady(false);
    if (!token) { setProgress({}); setReady(true); return; }
    let alive = true;
    api('/progress', { token })
      .then(d => { if (alive) { setProgress(d || {}); setReady(true); } })
      .catch(() => { if (alive) setReady(true); });
    return () => { alive = false; };
  }, [token]);

  const getPosition = useCallback((textId) => {
    return progress[textId] || 0;
  }, [progress]);

  const savePosition = useCallback((textId, sentenceIndex) => {
    setProgress(prev => ({ ...prev, [textId]: sentenceIndex }));
    if (STATIC) { progressStore.set(textId, sentenceIndex); return; }
    if (token) {
      api(`/progress/${encodeURIComponent(textId)}`,
          { method: 'PUT', token, body: { position: sentenceIndex } }).catch(() => {});
    }
  }, [token]);

  return { getPosition, savePosition, ready };
}
